import { LicenseInfo, muiXTelemetrySettings } from '@mui/x-license';

export function initRubiksLicense() {
    muiXTelemetrySettings.disableTelemetry();

    LicenseInfo.setLicenseKey(
        '084b8508ed3c04fce9253875dad88c41Tz0xMjk0MTcsRT0xODEzMDE3NTk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMS0yMDI2LFE9MTAsQVQ9bXVsdGksS1Y9Mg=='
    );
}
